// pages/AccessibilityStatement.js
// הצהרת נגישות — WCAG 2.1 AA
// נגיש מ: user menu → הצהרת נגישות, footer link

import { Box, Paper, Typography, Divider, useTheme } from '@mui/material';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import { useTranslation } from 'react-i18next';

export default function AccessibilityStatement() {
  const { t } = useTranslation();
  const theme = useTheme();
  const glassCard = theme.custom?.glassmorphism?.card || {};

  return (
    <Box
      data-testid="accessibility-statement__page"
      sx={{ maxWidth: 800, mx: 'auto', py: 2 }}
    >
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 4 },
          borderRadius: 3,
          ...glassCard,
        }}
      >
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
          <AccessibilityNewIcon color="primary" sx={{ fontSize: 32 }} />
          <Typography variant="h4" component="h1">
            {t('accessibilityStatement.title')}
          </Typography>
        </Box>

        <Divider sx={{ mb: 3 }} />

        {/* Intro */}
        <Typography variant="body1" paragraph>
          {t('accessibilityStatement.intro')}
        </Typography>

        {/* Standard */}
        <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 3 }}>
          {t('accessibilityStatement.standardTitle')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('accessibilityStatement.standardText')}
        </Typography>

        {/* Features */}
        <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 3 }}>
          {t('accessibilityStatement.featuresTitle')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('accessibilityStatement.featuresText')}
        </Typography>

        {/* Keyboard */}
        <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 3 }}>
          {t('accessibilityStatement.keyboardTitle')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('accessibilityStatement.keyboardText')}
        </Typography>

        {/* Contact */}
        <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 3 }}>
          {t('accessibilityStatement.contactTitle')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('accessibilityStatement.contactText')}
        </Typography>

        {/* Last updated */}
        <Divider sx={{ my: 3 }} />
        <Typography variant="caption" color="text.secondary">
          {t('accessibilityStatement.lastUpdated')}
        </Typography>
      </Paper>
    </Box>
  );
}
